module.exports = __webpack_public_path__ + "static/media/8.655c7213.jpg";